import { createContext } from 'react';
import { Table3DataContext } from '~/app/shared/table3tools/contexts/Table3DataContext';
import { ProductCollectionListViewModel } from '~/types/internal-api';

export const ProductCollectionTable3DataContext = createContext<Table3DataContext<ProductCollectionListViewModel>>(
    {} as Table3DataContext<ProductCollectionListViewModel>
);
